export default __webpack_public_path__ + "static/media/behance.c0c30243.svg";